(function(window, document, s, undefined){

  // Normalize the user agent identifier and assign it to s.browser
  s.browser = (function() {
    var ua = navigator.userAgent;
    var tem;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }

    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR\/(\d+)/);
      if (tem !== null) return 'Opera ' + tem[1];
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = ua.match(/version\/(\d+)/i)) !== null) M.splice(1, 1, tem[1]);

    return M.join(' ');
  })();


  // Append the name of the internet explorer version to the body's classes
  if (s.browser.indexOf('IE') > -1) {
    s.$body.addClass('ie' + s.browser.split(' ')[1]);
  }

})(this, this.document, window.s);
